import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import { base_url } from "Backend/api";
import { useNavigate } from "react-router-dom";
import AppSpinner from "components/ui/AppSpinner";

/** يبني رابط صورة التصنيف حسب ما يرجعه الباك (مسار نسبي تحت storage). */
function categoryImageSrc(image) {
  if (!image) return "/assets/images/logo.jpeg";
  const s = String(image).trim();
  if (/^https?:\/\//i.test(s)) return s;
  if (s.startsWith("/storage/")) {
    return `${String(base_url).replace(/\/$/, "")}${s}`;
  }
  if (s.startsWith("/")) {
    return `${String(base_url).replace(/\/$/, "")}${s}`;
  }
  return `${String(base_url).replace(/\/$/, "")}/storage/${s.replace(/^\//, "")}`;
}

function categoriesFromResponse(result) {
  if (!result?.status || result.data == null) return [];
  const raw = result.data;
  return Array.isArray(raw) ? raw : [];
}

const CategoriesSection = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(`${base_url}/api/restaurant/categories`, {
          headers: {
            Accept: "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        });

        const result = await response.json();
        setCategories(categoriesFromResponse(result));
      } catch (error) {
        console.error("Error fetching categories:", error);
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  if (loading) {
    return (
      <section
        id="categories"
        className="w-full scroll-mt-32 bg-[#F5F5F5] px-4 py-4 md:px-6 md:py-5 lg:px-8"
      >
        <div className="mx-auto max-w-7xl">
          <h2 className="mb-4 font-[cairo] text-[14px] font-bold text-gray-900 md:mb-5 md:text-[16px] lg:text-[18px]">
            تصنيفات المطاعم
          </h2>
          <div className="flex justify-center py-10">
            <AppSpinner />
          </div>
        </div>
      </section>
    );
  }

  if (categories.length === 0) {
    return null;
  }

  return (
    <section
      id="categories"
      className="w-full scroll-mt-32 bg-[#F5F5F5] px-4 py-4 md:px-6 md:py-5 lg:px-8"
    >
      <div className="mx-auto max-w-7xl">
        <h2 className="mb-4 font-[cairo] text-[14px] font-bold text-gray-900 md:mb-5 md:text-[16px] lg:text-[18px]">
          تصنيفات المطاعم
        </h2>

        <Swiper
          modules={[Navigation]}
          spaceBetween={12}
          slidesPerView="auto"
          dir="rtl"
        >
          {categories.map((category) => (
            <SwiperSlide key={category.slug} className="!w-auto">
              <button
                type="button"
                onClick={() =>
                  navigate(`/restaurants?category=${encodeURIComponent(category.slug)}`)
                }
                className="
                  group flex w-[82px] flex-col items-center gap-3 rounded-[8px] bg-white  pb-1 pl-0 pr-0
                  shadow-[0_2px_8px_rgba(0,0,0,0.06)] transition
                  hover:shadow-[0_4px_14px_rgba(0,0,0,0.08)]
                  sm:w-[90px] sm:gap-3.5 sm:rounded-[14px]  sm:pb-5 sm:pt-5 sm:pl-0 sm:pr-0
                  md:w-[100px] md:gap-4
                  lg:w-[110px]
                "
                aria-label={category.name}
              >
                <div
                  className="
                    shrink-0 overflow-hidden  
                    h-[58px] w-[68px]  pl-0 ml-[-14px] rounded-[8px]
                    sm:h-[76px] sm:w-[76px]  sm:ml-[-14px] sm:rounded-[8px] 
                    md:h-[84px] md:w-[84px] md:ml-[-14px] md:mt-[-20px] md:rounded-[8px]
                    lg:h-[86px] lg:w-[92px] lg:ml-[-16px] lg:mt-[-20px] lg:rounded-[8px]
                  "
                >
                  <img
                    src={categoryImageSrc(category.image)}
                    alt=""
                    className="h-full w-full object-cover"
                  />
                </div>

                <span
                  className="
                    line-clamp-2 w-full px-0.5 text-center font-[cairo] text-[11px] font-medium leading-snug
                    text-gray-900 transition group-hover:text-[#F93209] line-clamp-1
                    sm:text-[8px] md:text-[10px]
                  "
                >
                  {category.name}
                </span>
              </button>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default CategoriesSection;
